import { getOnboardingKbSession } from './onboardingKbSession';

// The Knowledge API's chatbot-create call takes no dataset ids, so the
// knowledge base built in onboarding's KB step is not linked to the inbox
// that onboarding creates: the sandbox chat reads it, the live inbox does
// not. This attaches it right after the chatbot exists with a partial
// PUT .../inboxes/:id/app carrying only dataset_ids (verified on staging: it
// leaves the rest of the config untouched). PUT .../inboxes/:id/datasets looks
// like the obvious call but answers 404 for a freshly created chatbot, since
// it looks up a Dify app id that does not exist yet.

// The store's datasetId is only trusted when it belongs to this account
// (the store resets on an account switch); the saved session survives a full
// page redirect, e.g. the detour through another channel's OAuth screen.
export const resolveOnboardingDatasetId = (accountId, store) => {
  const fromStore =
    store?.getters?.['onboardingKnowledge/accountId'] === accountId
      ? store.getters['onboardingKnowledge/datasetId']
      : null;
  return fromStore || getOnboardingKbSession(accountId)?.datasetId || null;
};

// Resolves true when the knowledge base is attached, or when there is nothing
// to attach (the user skipped the KB step). Never throws: attaching is a
// convenience on top of creating the inbox and must not fail the creation.
export const attachOnboardingKnowledge = async ({
  accountId,
  inboxId,
  datasetId,
}) => {
  if (!accountId || !inboxId) return false;
  if (!datasetId) return true;
  try {
    await window.axios.put(
      `/api/v1/accounts/${accountId}/proxy/knowledge/chatbot/accounts/${accountId}/inboxes/${inboxId}/app`,
      { dataset_ids: [String(datasetId)] }
    );
    return true;
  } catch (error) {
    return false;
  }
};
